import React from 'react';

import RequireIcon from '../../RequireIcon';
import { QuestionIcon } from '../../icons/QuestionIcon';
import Tippy from '../../ReactTippy';
import _ from 'lodash';

const HeaderTemplate = ({
  name,
  isRequired = false,
  guideText = '',
  context,
}) => {
  const isFrozen = context.col.index + 1 <= context.col.grid.frozenColumns;
  return (
    <div className={`wj-cell-header ${isFrozen && 'wj-cell-header--bold'}`}>
      {name}
      {isRequired && <RequireIcon cssClass='required-icon' />}
      {guideText && (
        <Tippy
          duration={10}
          multiple={false}
          arrow={true}
          arrowType='sharp'
          placement='bottom'
          html={renderTooltipContent(guideText)}
        >
          <QuestionIcon className={'icon--2x question-icon'} />
        </Tippy>
      )}
      {_.get(context, 'col.grid.allowPinning') && (
        <button
          className={`wj-btn wj-btn-glyph wj-right wj-elem-pin ${isFrozen &&
            'wj-state-pinned'} `}
          type='button'
          tabIndex='-1'
          aria-pressed={isFrozen}
        >
          <span
            className='wj-glyph-pin'
            style={{ pointerEvents: 'none' }}
          ></span>
        </button>
      )}
    </div>
  );
};

/**
 * Tooltipで表示される文字
 * @param data {string}
 */
const renderTooltipContent = data => {
  const rowStyle = {
    maxWidth: '260px',
    wordWrap: 'break-word',
    color: '#FFF',
    fontSize: '14px',
    lineHeight: '1.5',
    textAlign: 'left',
  };

  return <div style={rowStyle}>{data}</div>;
};

export default HeaderTemplate;



// WEBPACK FOOTER //
// ./src/components/wijimo/templates/HeaderTemplate.jsx